import { MemberActivity } from '@/types/memberActivity.js';

export const getMemberActivityKey = (activity: MemberActivity) =>
  [
    activity.action_type,
    activity.user.id,
    activity.adp_document?.id ?? '',
    activity.comment?.id ?? '',
    activity.created_at,
  ].join(':');
